<template>
    <div>
        <div v-if="row.status == moneyRequestPaymentStatus.SUCCESS || row.status == moneyRequestPaymentStatus.PAID">
            <a target="_blank" :href="row.pay_link" class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                <span class="tooltip-text">{{ $t('label.pay_facture') }}</span>
                <i class="fas fa-file"></i>
            </a>
            <a type="button" @click="appendDataToModal(row)"
               class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip"
               data-toggle="modal" data-target="#description_modal">
                <span class="tooltip-text">{{ $t('label.detail_money_request_form') }}</span>
                <i class="fas fa-info-circle"></i>
            </a>
        </div>

        <div v-else >
            <a v-if="row.status !=moneyRequestPaymentStatus.CANCELLED && row.status !=moneyRequestPaymentStatus.CANCELLED_BY_ADMIN"
               target="_blank" :href="row.pay_link"
               class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                <span class="tooltip-text">{{ $t('label.pay_link') }}</span>
                <i class="fas fa-link"></i>
            </a>
            <a type="button" @click="appendDataToModal(row)"
               class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip"
               data-toggle="modal" data-target="#description_modal">
                <span class="tooltip-text">{{ $t('label.detail_money_request_form') }}</span>
                <i class="fas fa-info-circle"></i>
            </a>
            <button v-if="row.payment_method == 0 && row.status == moneyRequestPaymentStatus.INIT && row.has_transaction" type="button"
                    class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip"
                    @click="billInquiry()">
                <span class="tooltip-text">{{ $t('money_request.bill_inquiry') }}</span>
                <i :class="'fa fa-sync '+ icon_class"></i>
            </button>
        </div>
        <div id="description_modal" class="modal fade rtl" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <div id="title">
                        </div>
                        <button type="button" class="close float-right mr-0" data-dismiss="modal">&times;</button>
                    </div>
                    <div id="data_sheet" class="modal-body mb-4">
                        <table class="table table-hover">
                            <thead id="table-header">
                            <tr>
                                <th class="table-info" colspan="2">{{ $t('money_request.detail_money_request') }}</th>
                            </tr>
                            </thead>
                            <tbody id="transaction_detail">
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <span>
            <button type="button" class="btn btn-sm btn-clean btn-icon btn-icon-sm" data-toggle="dropdown"
                    data-target="#myModal">
                <i class="fa fa-cog"></i>
            </button>
            <div class="dropdown-menu">
                    <button v-if="row.status !=moneyRequestPaymentStatus.CANCELLED_BY_ADMIN"
                            id="change_status_to_cancelled_by_admin"
                            @click="changeStatus(row.hashid,moneyRequestPaymentStatus.CANCELLED_BY_ADMIN)"
                            class="dropdown-item"
                    >
                    {{ $t('money_request.change_status_to_cancelled_by_admin') }}
                </button>
                <button v-if="row.status !=moneyRequestPaymentStatus.INIT"
                        id="change_status_to_pending"
                        @click="changeStatus(row.hashid,moneyRequestPaymentStatus.INIT)"
                        class="dropdown-item"
                >
                    {{ $t('money_request.change_status_to_pending') }}
                </button>
            </div>
        </span>
        <div>
            <div id="description_modal1" class="modal fade rtl" role="dialog">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div id="title1">
                            </div>
                            <button type="button" class="close float-right mr-0" data-dismiss="modal">&times;</button>
                        </div>
                        <div id="data_sheet1" class="modal-body mb-4">
                            <table class="table table-hover">

                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Vue from "vue";
import $ from "jquery";
import {i18n} from '@/plugins/i18n'
import toastr from "toastr";
import {ivrService, moneyRequestService} from "@/common/api.service";
import {moneyRequestPaymentStatus, moneyRequestPaymentStatusStr} from "@/constants/moneyRequestPaymentStatus";


export default Vue.extend({
    data() {
        return {
            moneyRequestPaymentStatus, moneyRequestPaymentStatusStr,
            icon_class : ''
        }
    },
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        }
    },

    methods: {
        appendDataToModal(row) {
            function simpleText(data, title) {
                return '<tr><td style="width: 155px;">' + title + '</td>' +
                        '<td>' + data + '</td></tr>'
            }

            function simpleTextLtr(data, title) {
                return '<tr>' +
                        '<td style="width: 155px;">' + title + '</td>' +
                        '<td style="direction: ltr;">' + data + '</td>' +
                        '</tr>'
            }

            let transaction_detail = $('#transaction_detail').empty()
            let title = $('#title').empty()
            let ps_elements =
                    '<h4 class="modal-title float-left p-0 m-0">' +
                    i18n.t('money_request.detail_money_request') + '</h4>'

            title.append(ps_elements)

            ps_elements = ''
            ps_elements = simpleTextLtr(row.payer_phone_number, i18n.t('money_request.payer_phone_number'))
            transaction_detail.append (ps_elements)
            ps_elements = simpleTextLtr(row.payer_wage, i18n.t('money_request.payer_wage'))
            transaction_detail.append (ps_elements)
            ps_elements = simpleTextLtr(row.tracking_number, i18n.t('money_request.tracking_number'))
            transaction_detail.append (ps_elements)
            if (this.row.details.bill_id){
                ps_elements = simpleTextLtr(row.details.bill_id, i18n.t('money_request.bill_id'))
                transaction_detail.append (ps_elements)
            }
            if (this.row.details.pay_id) {
                ps_elements = simpleTextLtr(this.row.details.pay_id, i18n.t('money_request.pay_id'))
                transaction_detail.append (ps_elements)
            }
        },
        remindPayer(hashid) {
            moneyRequestService.remind(hashid).then(response => {
                this.toastr.success(response.data.message)
            }).catch(({response}) => {
                this.toastr.fail(response.data.message)
            })
        },
        changeStatus(hashid, status) {
            let params = {
                'status': status
            }
            moneyRequestService.changeStatus(hashid, params).then(response => {
                this.toastr.success(response.data.message)

            }).catch(({response}) => {
                this.toastr.fail(response.data.message)
            }).finally(this.datatable.reload())
        },
        billInquiry() {
            this.icon_class = 'fa-spin'
            ivrService.adminBillInquiry(this.row.hashid).then(response => {
                this.row.status = response.data.data.payment_status
                if (this.row.status == this.moneyRequestPaymentStatus.PAID)
                    return this.toastr.success(response.data.message)
                else
                    this.toastr.error(response.data.message)
            }).catch(({response}) => {
                this.toastr.error(response.data.message)
            }).finally(()=> {
                this.icon_class = ''
                this.datatable.reload()
            })
        }
    },
})

</script>

<style scoped>
</style>
